import React from 'react'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Button } from '@mui/material'

export type LikeButtonProps = {
    isRegistered: boolean
    onClick: () => void
}

const LikeButton: React.FC<LikeButtonProps> = ({ isRegistered, onClick }) => {
    return (
        <Button
            variant={isRegistered ? 'contained' : 'outlined'}
            startIcon={isRegistered ? <CheckCircleOutlineIcon style={{ color: 'white' }} /> : <ThumbUpIcon color='primary' />}
            onClick={() => onClick()}
        >
            To mě zajímá
        </Button>
    )
}
export default LikeButton
